import React from 'react';
/**
 * Use this to run a function only once (on mount).
 *
 * @param callback The function that should run only once.
 * @returns Nothing.
 */
export const useRunOnce = (callback) => {
    const hasRun = React.useRef(false);
    React.useEffect(() => {
        if (!hasRun.current) {
            callback();
            hasRun.current = true;
        }
    }, [callback]);
};
